import { render, staticRenderFns } from "./Estamento.vue?vue&type=template&id=e711645c&scoped=true&"
import script from "./Estamento.vue?vue&type=script&lang=js&"
export * from "./Estamento.vue?vue&type=script&lang=js&"
import style0 from "./Estamento.vue?vue&type=style&index=0&id=e711645c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e711645c",
  null
  
)

export default component.exports